// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-day-overview[data-v-958e7436]{width:100%}.notification-day-overview hr[data-v-958e7436]{margin-top:14px;margin-bottom:2px;border-color:var(--q4s-ink)}.notification-day-overview__date[data-v-958e7436]{font-style:normal;font-weight:700;font-size:12px;line-height:18px;letter-spacing:.6px;text-transform:uppercase;padding:2px 8px;margin-bottom:12px}", ""]);
// Exports
module.exports = exports;
